import { Fancybox } from '@fancyapps/ui';

export default function () {
    document.querySelectorAll('.open-popup').forEach(elem => {
        elem.addEventListener('click', function (e) {
            e.preventDefault();

            Fancybox.show(
                [
                    {
                        src: $(this).attr('href'),
                        type: 'iframe',
                    },
                ],
                {
                    showClass: 'open-popup-iframe-wrapper',
                    dragToClose: false
                }
            );
        });
    });

    document.querySelectorAll('[data-run-prompt]').forEach(elem => {
        elem.addEventListener('click', function (e) {
            e.preventDefault();

            Fancybox.show(
                [
                    {
                        src: $(this).attr('data-src'),
                        type: "inline"

                    },
                ],
                {
                    parentEl: document.querySelectorAll("form")[0]
                }
            );
        });
    });

    document.querySelectorAll('[data-run-fancybox=""]').forEach(elem => {
        elem.addEventListener('click', function (e) {
            e.preventDefault();

            Fancybox.show(
                [
                    {
                        src: $(this).data('src')
                    },
                ]
            );
        });
    });

    document.querySelectorAll('[data-run-fancybox="inline"]').forEach(elem => {
        elem.addEventListener('click', function (e) {
            e.preventDefault();

            Fancybox.show(
                [
                    {
                        src: $(this).attr('href'),
                        type: 'inline'
                    },
                ]
            );
        });
    });
}